"use strict";

var _classCallCheck = require("/Users/zero/localdev/personal/byoungz-gatsby/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/Users/zero/localdev/personal/byoungz-gatsby/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Path = void 0;

var PathDelay_1 = require("./PathDelay");

var Utils_1 = require("../../../../../Utils");

var Path = /*#__PURE__*/function () {
  function Path() {
    _classCallCheck(this, Path);

    this.clamp = true;
    this.delay = new PathDelay_1.PathDelay();
    this.enable = false;
    this.options = {};
  }

  _createClass(Path, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }

      if (data.clamp !== undefined) {
        this.clamp = data.clamp;
      }

      this.delay.load(data.delay);

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }

      this.generator = data.generator;

      if (data.options) {
        this.options = (0, Utils_1.deepExtend)(this.options, data.options);
      }
    }
  }]);

  return Path;
}();

exports.Path = Path;